import { render, staticRenderFns } from "./SettlementList.vue?vue&type=template&id=12b7958c&scoped=true&"
import script from "./SettlementList.vue?vue&type=script&lang=js&"
export * from "./SettlementList.vue?vue&type=script&lang=js&"
import style0 from "./SettlementList.vue?vue&type=style&index=0&id=12b7958c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7958c",
  null
  
)

export default component.exports